import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../../actionTypes';

import { infoCategoryDetailRequestCompleted } from '../../actions';

const { takeEvery, put } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    try {
        for (const lang of config.app.languages) {
            yield firestore.get({
                collection: `languages/${lang}/infoCategories`,
                doc: `${meta.id}`,
                storeAs: `infoCategory<${meta.id},${lang}>`,
            });
        }
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.infoCategory.detail' }));
    } finally {
        yield put(infoCategoryDetailRequestCompleted());
    }
}
export default function* () {
    yield takeEvery(types.INFO_CATEGORY_DETAIL_REQUEST, handler);
}
